import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-no-submenus',
    styleUrls: ['./no-submenus.component.scss'],
    templateUrl: './no-submenus.component.html',
    standalone: false
})
export class NoSubmenusComponent {

    @Input() selectedConsumerName: string;

    constructor() {}

}
